import type {
  Logout,
  SetRefreshToken,
  SetToken,
  SetAppIsAuthenticated,
  SetAuthStatus,
  IncrementEnterPinErrorCount,
  ClearEnterPinErrorCount,
  SetEnterHasPinError,
  SetShouldEnterPin,
  SetRuntimeToken,
  SetLoginError,
} from "./types";

const setToken: SetToken = (state, action) => {
  state.token = action.payload;
};

const setRefreshToken: SetRefreshToken = (state, action) => {
  state.refreshToken = action.payload;
};

const setRuntimeToken: SetRuntimeToken = (state, action) => {
  state.runtimeToken = action.payload;
};

const logout: Logout = (state) => {
  state.refreshToken = null;
  state.token = null;
  state.appIsAuthenticated = false;
  state.runtimeToken = null;
};

const setAppIsAuthenticated: SetAppIsAuthenticated = (state, action) => {
  state.appIsAuthenticated = action.payload;
};

const setAuthStatus: SetAuthStatus = (state, action) => {
  state.authStatus = action.payload;
};

const incrementEnterPinErrorCount: IncrementEnterPinErrorCount = (state) => {
  state.enterPinErrorCount = state.enterPinErrorCount + 1;
};

const clearEnterPinErrorCount: ClearEnterPinErrorCount = (state) => {
  state.enterPinErrorCount = 0;
};

const setEnterPinError: SetEnterHasPinError = (state, action) => {
  state.enterPinHasError = action.payload;
};

const setShouldEnterPin: SetShouldEnterPin = (state, action) => {
  state.shouldEnterPin = action.payload;
};

const setLoginError: SetLoginError = (state, action) => {
  state.loginError = action.payload;
};

export const reducers = {
  setRefreshToken,
  setToken,
  logout,
  setAppIsAuthenticated,
  setAuthStatus,
  incrementEnterPinErrorCount,
  clearEnterPinErrorCount,
  setEnterPinError,
  setShouldEnterPin,
  setRuntimeToken,
  setLoginError,
};
